import { THeader } from "@/app/types/types";
import CustomButton from "./CustomButton";

const Header = ({ 
    title, 
    description, 
    buttonText, 
    buttonStyle, 
    buttonTextStyle, 
    buttonHasIcon, 
    isCenter, 
    customClass, 
    buttonAction,
    customTitleClass
}: THeader) => {
    return (
        <div className={`custom_header flex justify-between items-center ${isCenter ? "justify-center" : ""} ${customClass}`}>
            <div>
                <h2 className={`text-h5 mb-6 ${customTitleClass}`}>{title}</h2>
                {description && <p className="text-bodyM opacity-60 pb-10">{description}</p>}
            </div>
            {buttonText && <CustomButton
                text={buttonText}
                hasIcon={buttonHasIcon}
                style={buttonStyle}
                customClass={buttonTextStyle}
                action={buttonAction}
            />}
        </div>
    );
}

export default Header;